<script>
  import { format } from 'svelte-i18n';

  import { getNotificationsContext } from '@client/components/notifications';

  import CreateForm from '@client/pages/staff/domains/modals/forms/create-form.svelte';

  import { DomainsService } from '@client/services/domains';

  import { appStore } from '@client/stores/app';

  const { addNotification } = getNotificationsContext();

  export let nextDisabled = true;
  export let onExecute = null;
  export let onRollback = null;
  export let step = { data: {} };

  let config = {
    adminEmail: '',
    allowClone: false,
    authCode: '',
    domainName: ''
  };

  let error = '';

  const executeCreateDomain = async () => {
    $appStore.loading = true;

    error = '';

    const response = await DomainsService.createDomain(config);

    $appStore.loading = false;

    if (response.status >= 400) {
      error = $format('label.FAILURE.DOMAIN_CREATION', {
        values: {
          message: response.message
        }
      });

      throw new Error(response.message);
    }

    addNotification({
      text: $format('label.SUCCESS.DOMAIN_CREATION', {
        values: {
          domain: config.domainName
        }
      }),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    step.data = {
      id: config.domainName
    };

    return response;
  };

  $: if (onExecute !== null) {
    onExecute(executeCreateDomain);
  }

  $: if (onRollback !== null) {
    onRollback(null);
  }

  $: nextDisabled = !config.domainName || !config.adminEmail || !config.authCode;
</script>

<CreateForm bind:config {error} />
